module.exports = __webpack_public_path__ + "img/8.22a4de7e.png";